import { TaskEither } from 'fp-ts/TaskEither';
import { fetchTE, fetchApi } from 'utils/request';

export const listAllNodepoolsTE = <E = CF.API.ApiError>(
  { userId, params }: { userId: string; params?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListNodePoolsResponse> =>
  fetchTE<CF.API.Compute.ListNodePoolsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/nodepools${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );

export const listAllNodepools = ({ userId, params }: { userId: string; params?: string }): Promise<CF.API.Compute.ListNodePoolsResponse> =>
  fetchApi<CF.API.Compute.ListNodePoolsResponse>({
    path: `/api/_api/v2/users/${userId}/nodepools${params ? `?${params}` : ''}`,
    method: 'GET',
  });

export const listNodepoolsTE = <E = CF.API.ApiError>(
  {
    userId,
    clusterId,
    params,
  }: {
    userId: string;
    clusterId: string;
    params?: string;
  },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListNodePoolsResponse> =>
  fetchTE<CF.API.Compute.ListNodePoolsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/compute_clusters/${clusterId}/nodepools${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );
